import type { AuditedEntityDto, PagedAndSortedResultRequestDto } from '@abp/ng.core';

export interface CreateWineDto {
  name: string;
  description?: string;
  fileAttachmentId?: number;
  wineryId: number;
  brand?: string;
  varietal?: string;
  type?: string;
  harvest?: string;
  stock: number;
  price: number;
  maxOrderQuantity?: number;
  isActive: boolean;
  externalCode?: string;
}

export interface GetWineDto extends PagedAndSortedResultRequestDto {
  keyword?: string;
  country?: string;
  wineryId?: number;
  region?: string;
  sommelierSlug?: string;
  externalCode?: string;
}

export interface UpdateWineDto {
  name: string;
  description?: string;
  fileAttachmentId?: number;
  wineryId: number;
  brand?: string;
  varietal?: string;
  type?: string;
  harvest?: string;
  stock: number;
  price: number;
  maxOrderQuantity?: number;
  isActive: boolean;
  externalCode?: string;
}

export interface WineDto extends AuditedEntityDto<number> {
  name?: string;
  description?: string;
  imageUrl?: string;
  fileAttachmentId?: number;
  wineryId: number;
  wineryName?: string;
  wineryRegion?: string;
  wineryCountry?: string;
  brand?: string;
  varietal?: string;
  type?: string;
  harvest?: string;
  stock: number;
  price: number;
  maxOrderQuantity?: number;
  isActive: boolean;
  externalCode?: string;
  idItemColppy?: string;
  stockValue: number;
}

export interface WineListWithTotalDto {
  items: WineDto[];
  totalStockValue: number;
  totalCount: number;
}
